export default {
  activeTasks: [],
  datasources: {},
  defaultPath: "/app/map",
  dsTreeExpanded: [],
  dsTreeState: {
    dsTree: [],
    loading: true,
    changed: false
  },
  isReadyToRender: false,
  globalLoading: "success",
  listeners: [],
  locale: "ru",
  modules: [],
  objectInfo: {},
  objectFields: {},
  theme: "light-theme",
  user_config: {
    datasources: {},
    objectInfoFields: {},
    baselayerId: 5,
    timeFormat: "DD-MM-YYYY HH:mm:ss",
    pageSize: {
      book: 10,
      userRoles: 10
    }
  },
  admin: false,
  local_admin: false,
  instance: "",
  demoGuest: false,
  settings: null
};
